import { Stack, styled } from "@mui/material";

export const RedesignListBackground = styled(Stack)(({ theme }) => ({
	minHeight: "100%",
	backgroundColor: theme.palette.grey[50],
	paddingBottom: theme.spacing(3),
}));
